import React from "react";
import {SiteData} from "../../Constants/siteData";
import {PageWrapper} from "../../Components/PageWrapper/PageWrapper";
import PageHeader from "../../Components/common/PageHeader";
import ServicePageTemplate from "../../Containers/ServiceContainers/ServicePageTemplate";
import {SEO} from "../../Components/SEO/SEO";

export default function TreeHealthConsulting() {
    return (
        <PageWrapper>
            <SEO title={SiteData.treeHealthConsulting.metaData.title} description={SiteData.treeHealthConsulting.metaData.description}/>
            <PageHeader header={SiteData.treeHealthConsulting.h1} subtitle={SiteData.treeHealthConsulting.subtitle}/>
            <ServicePageTemplate body={SiteData.treeHealthConsulting.body}/>
        </PageWrapper>
    )
}
